import useAthlete from 'hooks/athlete/useAthlete';

function useAthleteIsSharingPaymentMethods(athleteId: string | undefined): boolean {
  const { data: athlete } = useAthlete(athleteId);
  return ['Primary', 'Linked', 'Dependent'].includes(athlete?.data?.connectedType || '');
}

export default useAthleteIsSharingPaymentMethods;
